import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleConditionTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.condition.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BankStatementRuleConditionTypeEnum} enumeration values */
export const BankStatementRuleConditionTypeEnumI18n: EnumI18nInterface<BankStatementRuleConditionTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BankStatementRuleConditionTypeEnum.EQUAL]: 'Равно',
    [BankStatementRuleConditionTypeEnum.BIGGER_THAN]: 'Больше',
    [BankStatementRuleConditionTypeEnum.LOWER_THAN]: 'Меньше',
  },
  [I18nLocalesEnum.EN_US]: {
    [BankStatementRuleConditionTypeEnum.EQUAL]: 'Equals',
    [BankStatementRuleConditionTypeEnum.BIGGER_THAN]: 'Bigger than',
    [BankStatementRuleConditionTypeEnum.LOWER_THAN]: 'Lower than',
  },
};
